<template>
  <ag-modal-container
    :title="$t('company.title.addToken')"
    width="900px"
    @close="back"
  >
    <company-add-token-form
      v-if="demandList"
      v-model="value"
      :demand-list="demandList"
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        :disabled="loading"
        color="primary"
        class="ml-5"
        outlined
        @click="back"
        v-text="$t('general.cancel')"
      />
      <v-btn
        :loading="loading"
        :disabled="!isValid || loading"
        color="accent"
        class="ml-5"
        @click="submit"
        v-text="$t('general.validate')"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import CompanyAddTokenForm from '../components/CompanyAddTokenForm'

export default {
  name: 'CompanyAddTokenContainer',
  components: {
    CompanyAddTokenForm,
    AgModalContainer,
  },
  props: {
    companyId: {
      type: String,
      required: true,
    },
    demandId: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      value: {
        demandId: this.demandId,
        label: '',
        tokenNumber: null,
        bill: null,
      },
      demandList: null,
      loading: false,
      isValid: false,
    }
  },
  async mounted () {
    const demandList = await Repositories.company.getTokensDemandList(this.companyId)
    this.demandList = demandList.filter(demand => demand.status === 'inProgress')
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async submit () {
      this.loading = true
      try {
        await Repositories.company.sendAction(
          this.companyId,
          'addToken',
          this.value,
          { isFormData: true },
        )
        this.showSuccessNotification(this.$t('company.addToken.success'))
        this.back()
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
